// Dashboard filters (plus any extra params) -> URL query string params, skipping unset
// values. Array values (multi-select province / city) serialize comma-joined, which is
// the wire shape parse_filters expects.
export default function filterParams(filters, extra = {}) {
  const params = new URLSearchParams();
  Object.entries({ ...(filters || {}), ...extra }).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') params.append(key, value);
  });
  return params;
}
